module.exports = __webpack_public_path__ + "img/03.e4bc2b02.jpg";